import { createI18n } from "vue-i18n/dist/vue-i18n.cjs";
import { messages } from "@/locale";

export const i18n = createI18n({
  locale: "es",
  messages,
});

export const { t } = i18n.global;
